import { useCallback } from 'react';
import { TrackingController } from '../services/tracking/trackingController';

export const useTracking = (data?: any) => {
  return useCallback(
    (action: string, eventName: string, eventType: string, eventData?: any, extractorType: string = 'raw', priority: string = '2') => {
      const globalTrackingEnabled = data?.globalTrackingEnabled ?? true;
      const widgetTrackingEnabled = data?.enableTracking ?? false;

      TrackingController.trackWidgetAction(
        data?.widgetType,
        action,
        eventName,
        eventType,
        eventData,
        globalTrackingEnabled,
        widgetTrackingEnabled,
        extractorType,
        priority
      );
    },
    [data?.widgetType, data?.globalTrackingEnabled, data?.enableTracking]
  );
};
